import { useMutation } from "@apollo/client";
import Button from "components/Button/Button";
import Card from "components/Card/Card";
import { FullFormikInput } from "components/Form/StandardForm";
import { useSession } from "contexts";
import { Form, Formik } from "formik";
import { CreateMroLocationDocument, GetLocationsDocument, GetLocationsQuery, UpdateMroLocationDocument } from "graphql/generated";

export default function NewLocation({ closeFlyout }: { closeFlyout: () => void }) {
    const { user } = useSession();
    const [createLocation] = useMutation(CreateMroLocationDocument, {
        refetchQueries: [{ query: GetLocationsDocument, variables: { where : { mroOrganizationId: { equals: user?.mroOrganizationId } } } }],
    });
    const initialValues = {
        name: '',
        code: '',
    };
    return (
        <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values) => {
            createLocation({
                variables: {
                    input: {
                        mroOrganization: { connect: { id: user.mroOrganizationId } },
                        ...values
                    },
                },
            })
            .then(() => closeFlyout())
            .catch(console.error);
        }}>
            <Form className="flex flex-col gap-5 mx-5">
                <Card className="">
                    <div className="flex gap-5">
                        <FullFormikInput name="name" placeholder="Location Name" label="Name" />
                        <FullFormikInput name="code" placeholder="Location Code" label="Code" />
                    </div>
                </Card>
                <div className="flex justify-end">
                    <Button text="Create" color="navy" size="xs" type="submit" />
                </div>
            </Form>
        </Formik>
    );
}